import isEmpty from 'lodash/isEmpty';
import isNumber from 'lodash/isNumber';
import isBoolean from 'lodash/isBoolean';
import isArray from 'lodash/isArray';

const ON_NODE = (typeof window === 'undefined');

export const cookieDomain = (host = '') => {
  let domain = host;
  if (!ON_NODE && !domain && !!location) {
    domain = location.hostname;
  }
  return `.${domain.replace('www.', '')}`;
};

export const isNotEmpty = (val) => {
  if (isArray(val) && !isEmpty(val)) {
    return val.reduce((a, c) => (a || isNotEmpty(c)), false);
  }

  return !isEmpty(val) || isNumber(val) || isBoolean(val);
};

// map the browser names so that it matches what is currently in analytics db
export const translateBrowserName = (browser) => {
  if (!browser) { return 'Other'; }

  switch (browser.name) {
    case 'edge':
      if (isAndroid(browser.os) || isIOS(browser.os)) {
        return 'Edge Mobile';
      }
      return 'Edge';
    case 'chrome':
      if (isAndroid(browser.os)) {
        return 'Chrome Mobile';
      }
      return 'Chrome';
    case 'crios':
      return 'Chrome Mobile iOS';
    case 'firefox':
      if (isAndroid(browser.os)) {
        return 'Firefox Mobile';
      }
      return 'Firefox';
    case 'fxios':
      return 'Firefox iOS';
    case 'opera':
      if (isAndroid(browser.os) || isIOS(browser.os)) {
        return 'Opera Mobile';
      }
      return 'Opera';
    case 'ie':
      if (isAndroid(browser.os)) {
        return 'IE Mobile';
      }
      return 'IE';
    case 'samsung':
      return 'Samsung Internet';
    case 'android':
      return 'Android';
    case 'ios':
      return 'Mobile Safari';
    case 'safari':
      return 'Safari';
    case 'facebook':
      return 'Facebook';
    case 'instagram':
      return 'Instagram';
    case 'vivaldi':
      return 'Vivaldi';
    default:
      return 'Other';
  }
};

function isAndroid(browserOs) {
  return browserOs === 'Android OS';
}

function isIOS(browserOs) {
  return browserOs === 'iOS';
}
